import { useWatch } from 'react-hook-form';
import { BaseOption } from 'components/forms/multiSelectField/MultiSelectField.types';
import { CustomTemplate } from 'models/automation/CustomTemplates';

const useSearchedCustomTemplates = (): string | undefined => {
  const searchedCustomTemplates: CustomTemplate[] | BaseOption[] | undefined =
    useWatch({
      name: 'customTemplateSearch',
    });

  if (!searchedCustomTemplates?.length) {
    return undefined;
  }

  const [chosenCustomTemplate] = searchedCustomTemplates;

  return 'label' in chosenCustomTemplate
    ? chosenCustomTemplate.label
    : chosenCustomTemplate.name;
};

export default useSearchedCustomTemplates;
